import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector, connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { miscellaneousTaskGet } from "../../../../redux/actions";
import _Edit from "../../../images/edit.svg";
import _Close from "../../../images/close.svg";
import _Agreed from "../../../images/agreed.svg";
import _Disagreed from "../../../images/disagreed.svg";

export const ViewPredefinedTaskDrawer = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(
      miscellaneousTaskGet({
        Task: [
          {
            TaskId: props.TaskId,
          },
        ],
      })
    );
  }, []);

  const { taskDetails } = useSelector(
    ({ miscellaneous_task_get: { data: taskGet } }) => {
      return {
        taskDetails: taskGet?.Data?.Tasks?.[0] || {},
      };
    },
    shallowEqual
  );
  const { TaskId, Title, Detail, DateInsertedDDMMMYYYY, Status } =
    taskDetails || {};
  return (
    <>
      <div className={`card card-custom`}>
        {/* Head */}
        <div className="card-header border-0 pl-4 pt-5">
          <h3>Task Details </h3>
          <OverlayTrigger overlay={<Tooltip id="close-tooltip">Close</Tooltip>}>
            <a
              className="btn btn-icon btn-hover-light-primary btn-sm"
              onClick={props.toggleDrawer("right", false, {})}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl(_Close)} />
              </span>
            </a>
          </OverlayTrigger>
        </div>
        {/* Body */}
        <div className="card-body pt-2 drawer-small-group drawer-details-view">
          <div className="row">
            <div className="col-11">
              {/* <span className="small-group-title">{GroupName}</span> */}
            </div>
            <div className="col-1">
              {/* <div>
                <OverlayTrigger
                  overlay={
                    <Tooltip id="edit-tooltip">Note type details</Tooltip>
                  }
                >
                  <span
                    className="btn btn-icon btn-hover-light-primary btn-sm"
                    onClick={() => {
                      history.push(`/community/group/edit?id=${GroupId}`);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG src={toAbsoluteUrl(_Edit)} />
                    </span>
                  </span>
                </OverlayTrigger>
              </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="row mb-5">
                <div className="col-md-6 col-sm-12 c-item">
                  <span className="c-label">Task ID</span>
                  <span className="c-value">{TaskId}</span>
                </div>
                <div className="col-md-6 col-sm-12 c-item">
                  <span className="c-label">Title</span>
                  <span className="c-value">{Title}</span>
                </div>
                <div className="col-md-6 col-sm-12 c-item">
                  <span className="c-label">Detail</span>
                  <span className="c-value">{Detail}</span>
                </div>
                <div className="col-md-6 col-sm-12 c-item">
                  <span className="c-label">Status</span>
                  <span className="c-value">{Status}</span>
                </div>
                <div className="col-md-6 col-sm-12 c-item">
                  <span className="c-label">Date Inserted</span>
                  <span className="c-value">{DateInsertedDDMMMYYYY}</span>
                </div>
              </div>
              <div className="row mb-5"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
